import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//import { InfoComponent } from './info/info.component';
//import { MainComponent } from './main/main.component';
import { MainLayoutService } from './layouts/main-layout/MainLayoutService';
import { InfoLayoutService } from './layouts/info-layout/InfoLayoutService';

const routes: Routes = [
  //{ path: 'info', component: InfoComponent },
  //{ path: '', redirectTo: '/main', pathMatch: 'full' },
  //{ path: 'main', component: MainComponent },
  MainLayoutService.childRoutes([
    {
      path: '',
      loadChildren:'./main/MainModule#MainModule'
    },
    {
      path: 'main',
      loadChildren: './main/MainModule#MainModule'
    },
    // {
    //   path: 'info',
    //   loadChildren: './info/InfoModule#InfoModule'
    // },
  ]),
  InfoLayoutService.childRoutes([
   {
     path: 'info',
     loadChildren: './info/InfoModule#InfoModule'
   },
   {
    path: 'policy',
    loadChildren: './policy/PolicyModule#PolicyModule'
  },
  ]),

  // Fallback when no prior route is matched
  { path: '**', redirectTo: 'main', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

//export const routingComponents = [InfoComponent, MainComponent];
